import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Checkbox } from '../checkbox/checkbox.component';

export const Container: StyledComponent<'div'> = styled.div``;

export const Header: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${Color.Black};
  background-color: ${Color.Gray100};
  padding: 26px 16px 14px;
`;

export const StyledCheckbox: StyledComponent<typeof Checkbox> = styled(Checkbox)`
  border-bottom: 1px solid ${Color.Gray300};
  padding: 18px 16px;
  width: 100%;
`;
